module.exports = __webpack_public_path__ + "img/icon-kpi.999c7df6.svg";